import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import type { Point as HighchartsPoint, TooltipOptions } from "highcharts";
import { renderToString } from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { ChartTooltip } from "@similarweb/ui-components";

import DurationService from "app/services/DurationService";
import { useTranslation } from "pro-features/components/WithTranslation";

import { getColumnDefinition } from "./getColumnDefinition";

export const useTooltipConfig = () => {
    const {
        params: { duration },
    } = useCurrentStateAndParams();
    const translate = useTranslation();

    return useMemo(() => {
        const durationData = DurationService.getDurationData(duration);
        const columnDefinition = getColumnDefinition(translate);

        return {
            ...tooltipContainerConfig().tooltip,
            outside: true,
            useHTML: true,
            formatter: function (this: HighchartsPoint) {
                const data = (this.points ?? []).reverse().map((point) => ({
                    label: {
                        value: point.series.name,
                        color: String(point.color),
                    },
                    value: `${point.y}%`,
                }));

                return renderToString(
                    <ChartTooltip
                        width={268}
                        title={String(this.category)}
                        subtitle={durationData.forWidget as string}
                        columnDefinition={columnDefinition}
                        data={data}
                    />,
                );
            },
        } satisfies TooltipOptions;
    }, [duration, translate]);
};
